// ONE GPO filter, used by every Order Execution sub-tab that lists rows.
//
// The point is that it is learnable once: same placement (first control on the tab's filter
// bar), same behaviour (substring, case-insensitive) and same wording as the two that
// already shipped — Procurement → Purchase Orders (339c19c) and Finance → Purchase Invoices
// (e6a7adc). A person who has used one has used all of them.
//
// SUBSTRING, NOT PREFIX. "175" has to find 1750–1759, and the useful fragment is often in
// the middle of a longer key ("42600111-9" is the tail of TPO-42600111-9). A startsWith
// match would find nothing in both cases.
//
// MODULE-LEVEL, not defined inside a parent component — a component redefined on every
// render gets a new identity, React unmounts and remounts it, and the input loses focus on
// every keystroke. That was the bug behind the original PO filter bar comment; keep it here.
import React from 'react';

// Case-insensitive substring over any set of fields. Empty query matches everything, so
// callers can pass it straight through without a guard.
export const matchesGpo = (q, ...fields) => {
  const s = String(q || '').trim().toLowerCase();
  if (!s) return true;
  return fields.some(f => String(f == null ? '' : f).toLowerCase().includes(s));
};

const boxStyle = {
  padding: '7px 10px', border: '1px solid #ddd', borderRadius: 6,
  fontSize: 13, boxSizing: 'border-box', width: 150,
};

export default function GpoFilter({ value, onChange, placeholder, width, title }) {
  return (
    <input
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder || 'Filter by GPO…'}
      title={title || 'Partial match — "175" finds 1750–1759'}
      style={{ ...boxStyle, ...(width ? { width } : {}) }}
    />
  );
}

// The count line every filtered list shows, so an empty table is never ambiguous — it says
// whether the list is genuinely empty or the filter emptied it. Same idea as the PO tab's.
export function FilterCount({ shown, total, noun, q }) {
  const filtering = String(q || '').trim().length > 0;
  if (!filtering) return null;
  return (
    <div style={{ fontSize: 12, color: shown === 0 ? '#A32D2D' : '#888', margin: '6px 0' }}>
      {shown === 0
        ? `Nothing matched GPO “${q.trim()}” — ${total} ${noun} on the tab.`
        : `${shown} of ${total} ${noun} matching GPO “${q.trim()}”.`}
    </div>
  );
}
